export * from "./poster.schema";
